import React, { Component } from 'react';

class SelectInput extends Component {
    componentDidMount () {
        if (this.props.defaultValue) {
            let searchKey = this.props.searchKey || '_id';
            let chosen = this.getDefault(this.props.options, searchKey, this.props.defaultValue);
            if (chosen) {
                this.onChange(chosen._id);
            } else {
                this.onChange(null);
            }
        } else {
            this.onChange(null);
        }
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.defaultValue !== this.props.defaultValue) {
            let searchKey = nextProps.searchKey || '_id';
            let chosen = this.getDefault(nextProps.options, searchKey, this.props.defaultValue);
            if (chosen) {
                this.onChange(chosen._id);
            } else {
                this.onChange(null);
            }
        }
        if (!nextProps.defaultValue) {
            this.onChange(null);
        }
    }

    getDefault (options, searchKey, defaultValue) {
        return options.find(item => item[searchKey] === defaultValue);
    }

    renderOptions () {
        let options = this.props.options;
        return options.map((option, index) => {
            return (
                <option key={index} value={option._id}>{option.name}</option>
            );
        });
    }

    onChange (value) {
        this.props.onChange(value);
    }

    render () {
        let searchKey = this.props.searchKey || '_id';
        return (
            <select
                className='input-field'
                defaultValue={this.getDefault(this.props.options, searchKey, this.props.defaultValue)._id}
                onChange={(event) => this.onChange(event.target.value)}>
                {this.renderOptions()}
            </select>
        );
    }
}

export default SelectInput;



// WEBPACK FOOTER //
// ./src/views/components/selectInput.js